import { Injectable, WritableSignal, signal } from '@angular/core';
import { TestScenarioService } from 'app/api/api/testScenario.service';
import { TestScenario } from 'app/api/model/testScenario';

@Injectable({
    providedIn: 'root',
})
export class TestService {
    // all test scenarios (for all processes)
    private _testScenarios: WritableSignal<Array<TestScenario>> = signal(null);

    constructor(private apiService: TestScenarioService) {}

    get testScenarios() {
        return this._testScenarios();
    }

    set testScenarios(scenarios: Array<TestScenario>) {
        this._testScenarios.set(scenarios);
    }

    getAllTestScenarios(): void {
        this.apiService.backendApiTestScenarioGet().subscribe(scenarios => {
            this._testScenarios.set(scenarios);
        });
    }

    updateTestScenarios(scenario: TestScenario) {
        this._testScenarios.update(scenarios => [...scenarios, scenario]);
    }
}
